import { render, staticRenderFns } from "./MovementNoteCell.vue?vue&type=template&id=a0fec708&scoped=true"
import script from "./MovementNoteCell.vue?vue&type=script&lang=js"
export * from "./MovementNoteCell.vue?vue&type=script&lang=js"
import style0 from "./MovementNoteCell.vue?vue&type=style&index=0&id=a0fec708&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fec708",
  null
  
)

export default component.exports